module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0009#pref"
    }
  }, [_vm._v("Preface: “Baseball’s Sad Lexicon”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0011#ch01"
    }
  }, [_c('b', [_vm._v("1")]), _vm._v("  Baseball’s Golden Era and Dark Age")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0012#pt01"
    }
  }, [_c('span', {
    staticClass: "sm-b"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm-b"
  }, [_vm._v("ONE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BOYS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("TO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0014#ch02"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v("  The Irish Game: "), _c('i', [_vm._v("Johnny Evers in Troy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0016#ch03"
    }
  }, [_c('b', [_vm._v("3")]), _vm._v("  The Midwestern Game: "), _c('i', [_vm._v("Joe Tinker in Kansas City")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0018#ch04"
    }
  }, [_c('b', [_vm._v("4")]), _vm._v("  The Western Game: "), _c('i', [_vm._v("Frank Chance in Fresno")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0019#pt02"
    }
  }, [_c('span', {
    staticClass: "sm-b"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm-b"
  }, [_vm._v("TWO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CHICAGO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CENTURY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0020#ch05"
    }
  }, [_c('b', [_vm._v("5")]), _vm._v("  Baseball Revival, 1903–1905")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0021#ch06"
    }
  }, [_c('b', [_vm._v("6")]), _vm._v("  Baseball Insanity, 1906")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0022#pt03"
    }
  }, [_c('span', {
    staticClass: "sm-b"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm-b"
  }, [_vm._v("THREE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DYNASTIC")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CYCLES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0023#ch07"
    }
  }, [_c('b', [_vm._v("7")]), _vm._v("  Conquest into Culture, 1907")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0024#ch08"
    }
  }, [_c('b', [_vm._v("8")]), _vm._v("  Team of Destiny, 1908")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0026#ch09"
    }
  }, [_c('b', [_vm._v("9")]), _vm._v("  Destiny Dissolves, 1909–1912")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0027#epil"
    }
  }, [_vm._v("Epilogue: Hall of Fame")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0028#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0029#app"
    }
  }, [_vm._v("Appendix: Diaspora")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0030#abbrev"
    }
  }, [_vm._v("Abbreviations Used in Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0031#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0032#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05ac24b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-rapp-0008.vue
// module id = 75
// module chunks = 0